// Module 10.6 — neighbourhood parcels as HOLLOW extruded walls (§5): a WallGeometry ring along the
// areaPolygon (open interior, not a filled polygon). Base hue by kind; service status drives the
// non-colour grammar (motion/hatch/dim/outage) + fill height = served/demand. criticalCap marks the
// highest-priority loads. No runtime (v1-shaped snapshot) ⇒ stable "unknown" status, not an error.
import type { Load, LoadRuntime } from "../../domain/index";
import type { WallSpec } from "./spec";
import { KIND_BASE_HUE, STATUS_STYLE } from "./palette";

export function encodeWalls(loads: readonly Load[], runtimeById: ReadonlyMap<string, LoadRuntime>): WallSpec[] {
  const out: WallSpec[] = [];
  for (const l of loads) {
    if (!l.areaPolygon) continue; // no footprint geometry → nothing to extrude
    const rt = runtimeById.get(l.id as string);
    const status = rt ? rt.status : "unknown";
    const style = STATUS_STYLE[status];
    const fillHeightFrac = rt && rt.demandMw > 0 ? Math.max(0, Math.min(1, rt.servedMw / rt.demandMw)) : 0;
    out.push({
      id: l.id as string,
      ring: l.areaPolygon,
      hollow: true,
      baseColor: KIND_BASE_HUE[l.kind],
      fillHeightFrac,
      status,
      motion: style.motion,
      hatch: style.hatch,
      dim: style.dim,
      criticalCap: l.criticalityPriority === 1,
      outageGlyph: style.outageGlyph,
    });
  }
  return out;
}
